import type { AppearanceContrast } from "@cmmd-forge/contracts/settings";

/**
 * Writes the contrast knobs the `--contrast-*` axis in `index.css` derives
 * from. 100 is the shipped look and disables mixing entirely; above it the
 * axis raises text and border contrast from the semantic roles, below it
 * softens them. The borders take a quarter of the boost so outlines do not
 * outrun the text they enclose.
 */
export function applyAppearanceContrast(root: HTMLElement, contrast: AppearanceContrast): void {
  root.style.setProperty("--appearance-contrast-base", `${Math.min(contrast, 100)}%`);
  root.style.setProperty("--appearance-contrast-boost", `${Math.max(contrast - 100, 0)}%`);
  root.style.setProperty(
    "--appearance-contrast-border-boost",
    `${Math.max(contrast - 100, 0) / 4}%`,
  );
}
